<template>
  <JdsDialog @close="$emit('close')">
    <template #header>
      <div class="fe-text-heading-xxs lg:fe-text-heading-xs">
        Your review matters
      </div>
    </template>

    <template #body>
      <div
        class="fe-mt-base fe-text-body-s fe-text-primary-grey-80 sm:fe-mb-m lg:fe-mb-l"
      >
        If you go back, all your written feedback will be lost. Continue
        reviewing?
      </div>
    </template>

    <template #footer>
      <div
        class="fe-grid fe-grid-cols-2 fe-gap-s lg:fe-grid-cols-4 lg:fe-justify-end fe-items-center"
      >
        <JdsButton
          size="medium"
          variant="secondary"
          className="lg:fe-col-start-3"
          @click="handleClose"
        >
          Go Back
        </JdsButton>
        <JdsButton @click="handleDialogClose" size="medium" variant="primary">
          Continue
        </JdsButton>
      </div>
    </template>
  </JdsDialog>
</template>

<script>
  import JdsDialog from "@/components/DesignSystem/JdsDialog/JdsDialog.vue"
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import { modalMixin } from "@/mixins/modalMixin"

  export default {
    name: "GoBackDialog",
    components: {
      JdsDialog,
      JdsButton,
    },
    mixins: [modalMixin],
    methods: {
      handleClose() {
        this.closeDialog()
        this.closeModal()
      },
      handleDialogClose() {
        this.closeDialog()
      },
    },
  }
</script>
